import React, { createContext, useContext, useState } from 'react';

interface GalleryContextProps {
  setActiveImage: (index: number) => void;
  getActiveImage: () => number;
  setCurrentSlider: (currentSlider: any) => void;
  getCurrentSlider: () => any;
  getIsZoom: () => boolean;
  setIsZoom: (flag: boolean) => void;
}

export const GalleryContext = createContext<GalleryContextProps>(null);

export const useGalleryContext = (): GalleryContextProps => useContext(GalleryContext);

export const GalleryContextProvider = ({ children, ...props }): JSX.Element => {
  const [image, setImage] = useState<number>(0);
  const [slider, setSlider] = useState();
  const [zoom, setZoom] = useState<boolean>(false);

  return (
    <GalleryContext.Provider
      value={{
        getActiveImage: () => image,
        getCurrentSlider: () => slider,
        getIsZoom: () => zoom,
        setActiveImage: (index) => setImage(index),
        setCurrentSlider: (currentSlider) => setSlider(currentSlider),
        setIsZoom: (flag) => setZoom(flag),
      }}
      // props need to be passed in this way
      // eslint-disable-next-line
      {...props}
    >
      {children}
    </GalleryContext.Provider>
  );
};

export default GalleryContextProvider;
